import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=5f0597df&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/users/UserAdd.vue
// module id = 1436
// module chunks = 0